import { Fragment, useState } from "react";
import { ArrowRight } from "react-feather";
import { Btn, H5, Image, P } from "../../../../AbstractElements";
import { ExploreMore, Simple, SimpleText, Upto } from "../../../../Constants/Constants";
import { dynamicImage } from "../../../../Utils";
import CommonModal from "../Common/CommonModal";

const SimpleModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const data = {isOpen: modal,toggler: toggle};
  return (
    <Fragment>
      <Btn color="secondary" onClick={toggle}>{Simple}</Btn>
      <CommonModal modalData={data}>
        <div className="modal-toggle-wrapper">
          <H5>{Upto}
            <strong className="txt-danger">{"85% OFF"}</strong>
            {SimpleText}
          </H5>
          <div className="modal-img">
            <Image src={dynamicImage(`gif/online-shopping.gif`)} alt="online-shopping" />
          </div>
          <P className="text-sm-center">{"Our difficulty in finding regular clothes that was of great quality, comfortable, and didn't impact the environment given way to Creatures of Habit."}</P>
          <Btn color="primary" className="d-flex align-items-center gap-2 text-light ms-auto" type="button" onClick={toggle}>
            {ExploreMore} <ArrowRight />
          </Btn>
        </div>
      </CommonModal>
    </Fragment>
  );
};
export default SimpleModal;
